import { Pipe, PipeTransform } from '@angular/core'
import dayJS from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
import { MomentTimeService } from '@wm-front/core'

dayJS.extend(calendar)

@Pipe({
  name: 'dateFromNow',
  standalone: true,
})
export class DateFromNowPipe implements PipeTransform {
  private _atWord = $localize`:@@dateFormNowAt:at`

  /** Convert un-formatted data to a formatted string */
  public transform(date: Date, granularity: 'day' | 'hour' = 'day'): string {
    if (date) {
      /** ensure the date is displayed with today, tomorrow and yesterday **/
      return `${dayJS(date).calendar(
        dayJS(),
        MomentTimeService.calendarConfig
      )}${
        granularity === 'day'
          ? ''
          : ` ${this._atWord} ${dayJS(date).format('HH:mm')}`
      }`
    }

    return '---'
  }
}
